<template>
	<div class="manage">
		<div class="bodymanage">
			<div class="top">
				<div class="topLeft">
					<!-- <div class="tabs">
          <div
            v-for="(item, index) in state"
            :key="index"
            class="btn"
            :class="{ selectBtn: index == nowIDx }"
            @click="cutState(index)"
          >
            <span>{{ item }}</span> -->
				</div>
			</div>
			<div class="flex">
				<div>
					<el-button
						size="small"
						type="primary"
						@click="goCreateGoods"
						style="margin: 10px;"
						>新增商品</el-button
					>
					<el-button
						size="small"
						type="primary"
						@click="adds"
						style="margin: 10px;"
						>新增商品类目</el-button
					>
					是否可余额抵扣设置 :
					<el-switch
						v-model="status"
						@change="set"
						active-text="是"
						inactive-text="否"
						active-color="#13ce66"
						inactive-value="0"
						active-value="1"
						inactive-color="#ff4949"
					>
					</el-switch>
				</div>
				<div class="cont">
					<ul class="left">
						<li
							v-for="(item, index) in stockData"
							:key="index"
							@click="changeRouter(index)"
							:class="couponType == index ? 'current' : ''"
						>
							{{ item.name }}
						</li>
					</ul>
					<div class="right">
						<hr />
						<el-form
							v-if="key == 0"
							ref="form"
							:model="form"
							:inline="true"
							class="demo-form-inline"
							label-width="auto"
						>
							<el-form-item label="商品名称">
								<el-input
									v-model="form.keyword"
									placeholder="请输入商品名称"
								></el-input>
							</el-form-item>
							<!-- <el-form-item label="商品类型">
                <el-select v-model="form.type" placeholder="全部">
                  <el-option label="实物商品" value="goods"></el-option>
                  <el-option label="优惠券" value="coupon"></el-option>
                  <el-option label="余额" value="balance"></el-option>
                </el-select>
              </el-form-item> -->
							<el-form-item label="商品类型">
								<el-select
									v-model="form.goods_type"
									clearable
									placeholder="全部"
								>
									<el-option label="实物商品" :value="0"></el-option>
									<el-option label="优惠券" :value="1"></el-option>
									<el-option label="余额" :value="2"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="商品状态">
								<el-select v-model="form.status" clearable placeholder="状态">
									<el-option label="上架" :value="1"></el-option>
									<el-option label="下架" :value="0"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="是否联盟商品">
								<el-select
									clearable
									v-model="form.alliance_goods"
									placeholder="检索联盟商品"
								>
                <el-option label="全部" value=""></el-option>
									<el-option label="是" :value="1"></el-option>
									<el-option label="否" :value="0"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button
									type="primary"
									size="small"
									@click="getManagementList"
									>搜索</el-button
								>
							</el-form-item>
						</el-form>
						<el-table
							v-if="key == 0"
							fit
							ref="multipleSelection"
							:data="commodityList"
							v-loading="loading"
							:element-loading-text="loading_text"
							:default-sort="{ prop: 'date', order: 'descending' }"
							border
						>
							<el-table-column prop="id" label="商品ID" width="50px">
							</el-table-column>
							<el-table-column prop="pic" label="商品封面">
								<template slot-scope="scope">
									<div class="comPrice">
										<div class="img">
											<img :src="scope.row.pic" alt="" class="comImg" />
										</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="title" label="商品名称"></el-table-column>
							<el-table-column prop="money" label="商品类目">
								<template slot-scope="scope">
									<span>{{ scope.row.cate }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="credit" label="所需积分" align="left">
								<template slot-scope="scope">
									<div v-if="credit == scope.row.id">
										<el-input
											size="mini"
											style="margin-bottom: 10px;"
											v-model="input1"
											placeholder="请输入内容"
										></el-input>
										<div class="but2">
											<el-button
												size="mini"
												class="but"
												type="primary"
												@click="saveCredit(scope.row)"
												>保存</el-button
											>
											<el-button size="mini" class="but" @click="credit = ''"
												>取消</el-button
											>
										</div>
									</div>
									<div v-else>
										<span>{{ scope.row.credit }}</span>
										<el-button
											style="margin-left: 10px;"
											class="edit"
											size="mini"
											type="primary"
											icon="el-icon-edit"
											@click="editCredit(scope.row)"
										></el-button>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="money" label="所需金额">
								<template slot-scope="scope">
									<div class="comPrice">
										<div class="rgt">
											<span class="name">{{ scope.row.name }}</span>
											<span
												class="price"
												v-if="
													scope.row.money !== '' && scope.row.money !== null
												"
												>￥{{ scope.row.money }}</span
											>
											<span class="price" v-else>￥0.00</span>
										</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="stock" label="库存" align="left">
								<template slot-scope="scope">
									<div v-if="stock == scope.row.id">
										<el-input
											size="mini"
											style="margin-bottom: 10px;"
											v-model="input2"
											placeholder="请输入内容"
										></el-input>
										<div class="but2">
											<el-button
												size="mini"
												class="but"
												type="primary"
												@click="saveStack(scope.row)"
												>保存</el-button
											>
											<el-button size="mini" class="but" @click="stock = ''"
												>取消</el-button
											>
										</div>
									</div>
									<div v-else>
										<span>{{ scope.row.stock }}</span>
										<el-button
											style="margin-left: 10px;"
											class="edit"
											size="mini"
											type="primary"
											icon="el-icon-edit"
											@click="editStock(scope.row)"
										></el-button>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="time" label="创建时间">
								<template slot-scope="scope">
									<span>{{ scope.row.create_time }}</span>
								</template>
							</el-table-column>
							<el-table-column label="状态">
								<template slot-scope="scope">
									<el-tag
										:type="scope.row.status == 1 ? 'success' : 'danger'"
										effect="dark"
										v-html="scope.row.status == 1 ? '上架' : '下架'"
									>
									</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="sale" label="销量">
								<template slot-scope="scope">
									<span>{{ scope.row.conversion_num }}</span>
								</template>
							</el-table-column>
							<el-table-column label="联盟商品">
								<template slot-scope="scope">
									<el-tag
										:type="scope.row.alliance_goods == 1 ? 'success' : 'danger'"
										effect="dark"
										v-html="scope.row.alliance_goods == 1 ? '是' : '否'"
									>
									</el-tag>
								</template>
							</el-table-column>
							<el-table-column label="操作" fixed="right" header-align="center">
								<template slot-scope="scope">
									<el-button
										size="small"
										type="text"
										@click="handleClick(scope.row)"
										>兑换记录</el-button
									>
									<el-button
										size="small"
										type="text"
										@click="handleShelves(scope.row)"
										v-text="scope.row.status == 1 ? '下架' : '上架'"
									></el-button>
									<el-button
										size="small"
										type="text"
										@click="handleEdit(scope.row)"
										>编辑</el-button
									>
									<el-button
										type="text"
										size="small"
										@click="handleDelete(scope.row.id)"
										>删除</el-button
									>
								</template>
							</el-table-column>
						</el-table>
						<Addcategory v-if="key == 1" :val="val" />
						<AddLm :dialogFormVisible="dialogFormVisible" @add="add" />
						<el-pagination
							v-if="key == 0"
							@current-change="handleCurrentChange"
							layout="total, prev, pager, next, jumper"
							:total="total_num"
						>
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<Edit
			:editFormVisible="editFormVisible"
			:row="row"
			@edit="edit"
			@close="close"
		/>
		<el-dialog
			title="兑换记录"
			:visible.sync="IsVisible"
			@close="gb"
			width="60%"
		>
			<el-table :data="oders">
				<el-table-column property="order_sn" label="订单号"></el-table-column>
				<el-table-column property="good_type" label="商品类型">
					<template slot-scope="scope">
						<span
							v-text="
								scope.row.goods_type == 0
									? '实物商品'
									: scope.row.goods_type == 1
									? '优惠券'
									: '余额'
							"
						></span>
					</template>
				</el-table-column>
				<el-table-column
					property="balance"
					label="余额值"
					v-if="form.goods_type == 2"
				>
					<template slot-scope="scope">
						<span>{{ scope.row.balance }}</span>
					</template>
				</el-table-column>
				<el-table-column property="num" label="数量"> </el-table-column>
				<el-table-column property="buy_method" label="购买方式">
					<template slot-scope="scope">
						<span
							v-text="
								scope.row.buy_method == 1
									? '积分兑换'
									: scope.row.buy_method == 2
									? '积分加钱购买'
									: '金钱购买'
							"
						></span>
					</template>
				</el-table-column>
				<el-table-column label="消耗">
					<template slot-scope="scope">
						<span v-if="scope.row.buy_method == 1">{{
							scope.row.total_credit
						}}</span>
						<span v-else-if="scope.row.buy_method == 2">{{
							scope.row.total_credit + "+" + scope.row.total_money
						}}</span>
						<span v-else-if="scope.row.buy_method == 3">{{
							scope.row.total_money
						}}</span>
					</template>
				</el-table-column>

				<el-table-column property="status" label="订单状态">
					<template slot-scope="scope">
						<span
							v-text="
								scope.row.status == 0
									? '待核销'
									: scope.row.status == 1
									? '已核销'
									: scope.row.status == 2
									? '已发货'
									: scope.row.status == 3
									? '已收货'
									: '已取消'
							"
						></span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				@current-change="handleCurrentChanges"
				layout="total, prev, pager, next, jumper"
				:total="total_num"
			>
			</el-pagination>
		</el-dialog>
	</div>
</template>

<script>
// import {
//   productList,
//   deleteProduct,
//   allianceProductStatus,
// } from "@/api/integralMall";
import Edit from "../../conmpents/edit";
import { mapActions, mapGetters } from "vuex";
import {
  categoryList,
  deleteGoods,
  editGoods,
  getcreditshopconfig,
  ManagementList,
  modifyState,
  setcreditshopconfig
} from "@/api/market";
import { orderList } from "@/api/integralMall";
import AddLm from "../addlm";
import Addcategory from "./addcategory";
// import template from '../../../../newVip/set/smsConfig/template.vue';
export default {
	// components: { template },
	inject: ["reload"],
	computed: {
		...mapGetters(["token", "app_id", "merch_id"]),
	},
	components: {
		Edit,
		AddLm,
		Addcategory,
	},
	data() {
		return {
			oders: [],
			val: 0,
			IsVisible: false,
			form: {
				keyword: "",
				goods_type: "",
				alliance_goods: "", //商品类目
				status: "",
			},
			stock: false,
			couponType: 0,
			idx: 1,
			total_num: 0,
			keyword: "",
			page: "1",
			type: "",
			nowIDx: 0,
			loading: true,
			loading_text: "正在加载中...",
			state: ["全部商品", "出售中", "已售罄", "仓库中"],
			tableData: [],
			stockData: [
				{
					name: "商品管理",
				},
				{
					name: "商品类目",
				},
			],
			value: "",
			editFormVisible: false,
			modityStatus: false,
			// 选中
			multipleSelection: [],
			commodityList: [],
			// 添加商品弹窗
			addProduct: false,
			row: {},
			arrs: [],
			key: 0,
			dialogFormVisible: false,
			good_id: "",
			status: "",
			input2: "",
			credit: "",
			input1: "",
		};
	},

	mounted() {
		// this.productLists();
    this.Commodity_category();
		this.getManagementList();
		this.getcreditshopconfig();
	},
	methods: {
		editStock(row) {
			console.log(row);
			this.stock = row.id;
			this.input2 = row.stock;
		},
		saveStack(row) {
			console.log(row);
			let data = {
				title: "",
				cate: "",
				goods_type: 0,
				coupon_id: "",
				balance: "",
				room_id: "",
				logo: "",
				buy_method: 1,
				credit: "",
				money: "",
				stock: "",
				sort: "",
				brife: "",
				notice: "1",
				exchange_process: "1",
				alliance_goods: "0",
			};
			let arr = Object.keys(data);
			arr.map((item) => {
				data[item] = row[item];
			});
			data.app_id = this.app_id;
			data.id = row.id;
			data.stock = this.input2;
			data.credit = row.credit;
			this.arrs.push({
				id: 0,
				name: "全部",
			});
			data.cate = this.arrs.find((x) => x.name).id;

			editGoods(data).then((res) => {
				console.log(res);
				if (res.code == 200) {
					this.$message.success(res.msg);
					this.stock = "";
					this.getManagementList();
				}
			});
		},
		editCredit(row) {
			this.credit = row.id;
			this.input1 = row.credit;
		},
		saveCredit(row) {
			let data = {
				title: "",
				cate: "",
				goods_type: 0,
				coupon_id: "",
				balance: "",
				room_id: "",
				logo: "",
				buy_method: 1,
				credit: "",
				money: "",
				stock: "",
				sort: "",
				brife: "",
				notice: "1",
				exchange_process: "1",
				alliance_goods: "0",
			};
			let arr = Object.keys(data);
			arr.map((item) => {
				data[item] = row[item];
			});
			data.app_id = this.app_id;
			data.id = row.id;
			data.credit = this.input1;
			data.stock = row.stock;
			this.arrs.push({
				id: 0,
				name: "全部",
			});

			data.cate = this.arrs.find((x) => x.name).id;

			// data.cate = this.arrs.find((x) => x.name).id;
			editGoods(data).then((res) => {
				console.log(res);
				if (res.code == 200) {
					this.$message.success(res.msg);
					this.credit = "";
					this.getManagementList();
				}
			});
		},
		adds() {
			this.dialogFormVisible = true;
		},
		add(val) {
			this.dialogFormVisible = val;
			this.val = 1;
		},
		gb() {
			console.log("guanbi");
			this.IsVisible = false;
			this.total_num = 0;
			this.page = 1;
			this.reload();
			this.getManagementList();
		},
		close(val) {
			console.log("zozujian", val);
			this.editFormVisible = val;
		},
		...mapActions(["sethttp"]),
		getIndex(index) {
			return 10 * (this.page - 1) + index + 1;
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getManagementList();
		},
		handleCurrentChanges(val) {
			this.page = val;
			this.orderList();
		},
		changeRouter(index) {
			console.log(index);
			// this.$router.push(`${this.stockData[index].path}`);
			if (this.stockData[index].name == "商品管理") {
				this.couponType = index;
				this.key = index;
			}
			if (this.stockData[index].name == "商品类目") {
				this.couponType = index;
				this.key = index;
			}
		},
		// 兑换记录
		handleClick(row) {
			this.IsVisible = true;
			this.form.good_type = row.good_type;
			this.form.buy_method = row.buy_method;
			this.good_id = row.id;
			this.orderList();
		},
		orderList() {
			let data = {
				app_id: this.app_id,
				page: this.page,
				good_id: this.good_id,
			};
			orderList(data).then((res) => {
				console.log("res", res);
				if (res.code == 200) {
					this.oders = res.data.result;
					this.total_num = res.data.total_num;
				}
			});
		},
		// 商品状态
		handleShelves(row) {
			console.log("status", row);
			var data = {
				id: row.id,
				app_id: this.app_id,
				field: "status",
				value: row.status == 0 ? 1 : 0,
			};
			modifyState(data).then((res) => {
				console.log("res", res);
				if (res.code == 200) {
					this.$message({
						message: res.msg,
						type: "success",
					});
				} else {
					this.$message({
						message: res.msg,
						type: "error",
					});
				}
				this.getManagementList();
			});
		},
		// 保存商品状态
		async submitModify(row) {
			const data = await modifyState({
				app_id: this.app_id,
				id: row.id,
				status: this.modifyForm.status,
				field: "alliance_goods",
				value: row.alliance_goods ? 1 : 0,
			});
			console.log("status", row);
			if (data.code == 200) {
				this.$message({
					message: "商品状态修改成功",
					type: "success",
				});
			} else {
				this.$message({
					message: data.msg,
					type: "error",
				});
			}
			this.getManagementList();
			this.modityStatus = false;
		},

		// 选中的商品
		handleSelectionChange(val) {
			this.multipleSelection = val;
			console.log(this.multipleSelection);
		},
		// 商品来源去向
		goCreateGoods() {
			this.$router.push("optionProdduct");
		},

		// 获取商品管理列表
		async getManagementList() {
			try {
				const res = await ManagementList({
					app_id: this.app_id,
					page: this.page,
					keyword: this.form.keyword,
					goods_type: this.form.goods_type,
					alliance_goods: this.form.alliance_goods,
					status: this.form.status,
				});
				// console.log(,res)
				if (res.code == 200) {

					console.log("条数", res.data);
					if (res.data.total_num > 0) {
						this.loading = false;
						this.commodityList = res.data.result;
						this.total_num = res.data.total_num;
						this.commodityList.forEach((item, index) => {
              if(item.cate == 0) {
                item.cate = ''
              }else {
                this.arrs.forEach((items,index) => {
                  if(items.id == item.cate) {
                    item.cate = items.name
                  }
                })
              }
						})
					} else {
						this.loading = false;
					}
				}
			} catch (e) {
				console.log(e);
			}
		},
		handleEdit(data) {
			this.$router.push({
				path: "optionProdduct",
				query: {
					row: data,
				},
			});
			console.log("row", data);
			// this.arrs.forEach((item) => {
			// 	if (row.cate == item.name) {
			// 		row.cate = item.id;
			// 	}
			// });
			// this.row = row;
			// this.editFormVisible = true;
		},
		// 删除
		handleDelete(id) {
			console.log("--------");
			console.log(id);
			this.$confirm("此操作永久删除该商品，是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(async (res) => {
					const data = await deleteGoods({
						app_id: this.app_id,
						id: id,
					});
					console.log(data);
					if (data.code == 200) {
						this.$message({
							type: "success",
							message: "删除成功！",
						});
						this.getManagementList();
					}
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		//批量上架、下架
		shelves(data) {
			shelvesApi(data).then((res) => {
				console.log(res);
				this.$message({
					message: res.msg,
					type: "warning",
				});
				this.reload();
			});
		},
		// 删除
		delet(data) {
			deleteProduct(data).then((res) => {
				console.log(res);
				this.$message({
					message: res.msg,
					type: "warning",
				});
				this.reload();
			});
		},
		edit(val) {
			console.log("gaibian", val);

			if (val == false) {
				this.editFormVisible = val;
				this.getManagementList();
			}
		},
		Commodity_category() {
      categoryList({ token: this.token, app_id: this.app_id }).then(
				(res) => {
				  console.log(res)
					this.arrs = res.data;
				}
			);
		},
		set(val) {
			console.log("zhi", val);
			setcreditshopconfig({
				token: this.token,
				app_id: this.app_id,
				value: this.status,
			}).then((res) => {
				if (res.code == 200) {
					console.log(res);
					this.getcreditshopconfig();
					this.$message({
						type: "success",
						message: res.msg,
					});
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},
		getcreditshopconfig() {
			getcreditshopconfig({ token: this.token, app_id: this.app_id }).then(
				(res) => {
					if (res.code == 200) {
						this.status = res.data.value;
					} else {
						if (res.data.length == 0) {
							this.status = "1";
						}
					}
				}
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.edit {
	width: 50px;
	display: inline-block;
	// height: 30px;
}
.but2 {
	display: flex;
	justify-content: space-around;
}
.padding {
	padding: 20px;
}
.manage {
	height: 100%;
	padding: 0 55px 30px 30px;
	// background: #397dff;

	.bodymanage {
		height: 100%;
		.top {
			// min-height: 60px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.topLeft {
				height: auto;
			}
		}
		.selectBtn {
			background: #397dff;
			color: #fff;
			cursor: pointer;
		}
	}
	.filtrate {
		height: 36px;
		.top-right {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
	}
	.cont {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: space-around;
	}
	.left {
		width: 140px;
		height: 700px;
		margin-right: 15px;
		border: 1px solid #ebeef5;
		li {
			width: 100%;
			line-height: 50px;
			padding: 0 15px;
			border-bottom: 1px solid #ebeef5;
			cursor: pointer;
		}

		.current {
			background: #fafafa;
		}
	}
	.right {
		flex: 1;
		display: flex;
		overflow: hidden;
		flex-direction: column;
		.page {
			height: 50px;
			display: flex;
			align-items: center;
		}
		.el-table {
			flex: 1;
			margin-top: 20px;
			overflow-y: auto;
			border: 1px solid #ebeef5;
		}
		.el-form-item__label {
			padding: 4px 12px 0 0;
		}
		.el-input {
			width: 100%;
			position: relative;
			top: 2px;
		}
		.el-input__inner {
			height: 33px;
		}
		.comPrice {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			.img {
				width: 50px;
				height: 50px;
				overflow: hidden;
				line-height: 50px;
				.comImg {
					vertical-align: middle;
					width: 50px;
				}
			}
			.rgt {
				width: 60px;
				height: 50px;
				margin-left: 10px;
				display: flex;
				flex-direction: column;
				justify-content: space-around;
				font-size: 14px;
				text-align: left;
				.name {
					color: rgba(3, 87, 255, 1);
					font-weight: 400;
					line-height: 21px;
					max-width: 100px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
				.price {
					color: rgba(255, 91, 3, 1);
					font-weight: 400;
					line-height: 21px;
				}
			}
		}
		.el-pagination {
			height: 60px;
			padding-top: 16px;
		}
	}
}
</style>

<style lang="scss">
.manage {
	.el-button--small {
		padding: 9px 27px;
	}
	.cell {
		text-align: center;
	}
}
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
</style>
